import PropTypes from 'prop-types';
import { useEffect } from 'react';

/**
 * Google Merchant Widget Component
 * Displays Google Shopping seller ratings badge
 * Shows customer reviews and ratings for the merchant
 */
function GoogleMerchantWidget({
  merchantId = 5781111361,
  position = 'BOTTOM_RIGHT',
  region = 'KE',
}) {
  useEffect(() => {
    // Load Google Merchant Widget script
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.defer = true;
    document.head.appendChild(script);

    // Initialize widget when script loads
    const initWidget = () => {
      if (window.merchantwidget && window.merchantwidget.start) {
        window.merchantwidget.start({
          merchant_id: merchantId,
          position: position,
          region: region,
        });
      }
    };

    script.addEventListener('load', initWidget);

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [merchantId, position, region]);

  // This component doesn't render anything visible
  // The Google Merchant Widget renders the badge automatically
  return null;
}

GoogleMerchantWidget.propTypes = {
  merchantId: PropTypes.number,
  position: PropTypes.oneOf(['BOTTOM_RIGHT', 'BOTTOM_LEFT', 'TOP_RIGHT', 'TOP_LEFT']),
  region: PropTypes.string,
};

export default GoogleMerchantWidget;
